import * as serviceWorker from "./serviceWorker";
// import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
// import { Redirect, RouteComponentProps } from "react-router";
import { Provider } from "react-redux";
import { addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";

import store from "./redux/store";

import "./styles/style.scss";
import "./styles/s-alert.scss";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import "./styles/date-picker.scss";
import "react-datepicker/dist/react-datepicker.css";
import { Settings } from "luxon"

// import App from "./components/App";
import NewApp from "./NewApp";
// import AppWrapper from "./AppWrapper";

Settings.defaultZoneName = "Europe/Paris"

addLocaleData([...en, ...fr]);

ReactDOM.render(
  <Provider store={store}>
    <NewApp />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
